import { render, staticRenderFns } from "./LogoRevolugo.vue?vue&type=template&id=4874924f&scoped=true&"
import script from "./LogoRevolugo.js?vue&type=script&lang=js&"
export * from "./LogoRevolugo.js?vue&type=script&lang=js&"
import style0 from "./LogoRevolugo.scss?vue&type=style&index=0&id=4874924f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4874924f",
  null
  
)

export default component.exports